import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonSize, ButtonState, ButtonType } from '../../../assets/types/dtoTypes';
import { PATH } from '../../../assets/constants';
import { Router } from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {NgClass, NgIf} from "@angular/common";
import {ButtonComponent} from "../button/button.component";

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  standalone: true,
  imports: [
    NgClass,
    ButtonComponent,
    TranslateModule,
    NgIf
  ],
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent {
  private router = inject(Router);
  dialogRef = inject<MatDialogRef<PopupComponent>>(MatDialogRef);
  data = inject<{
    title?: string;
    message?: string;
    translationKey?: string;
    status?: 'isSuccess' | 'failure' | 'warning' | 'information';
    isConfirmation?: boolean;
    isBackToLogin?: boolean;
}>(MAT_DIALOG_DATA);

  status: 'isSuccess' | 'failure' | 'information' | 'warning' = 'information';

  iconPath: string;

  statusClass: string;

  isConfirmation: boolean = false;

  isBackToLogin: boolean;

  titleKey?: string;

  messageKey?: string;

  title?: string;

  message?: string;

  constructor() {
    const data = this.data;

    this.status = data.status || 'information';
    this.isConfirmation = data.isConfirmation || false;
    this.isBackToLogin = data.isBackToLogin || false;
    this.iconPath = `../../../assets/icons/${this.status}.svg`;
    this.statusClass = this.status;

    if ( data.translationKey ) {
      this.titleKey = `${data.translationKey}.title`;
      this.messageKey = `${data.translationKey}.message`;
    } else {
      this.title = data.title || '';
      this.message = data.message || '';
    }
  }

  closePopup( result: boolean = false ): void {
    this.dialogRef.close( result );
  }

  backtoLogin() {
    this.router.navigate( [ PATH.LOGIN ] );
    this.dialogRef.close();
  }

  protected readonly ButtonSize = ButtonSize;

  protected readonly ButtonState = ButtonState;

  protected readonly ButtonType = ButtonType;
}
